import { useHistory } from 'react-router-dom';
import PATHS from '../../../../../routes/routes.const';

export const useSeeAllConnections = () => {
  const history = useHistory();

  const goToConnections = () => {
    history.push(PATHS.main.myNetwork.path);
  };

  return { goToConnections };
};
